import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { FormlySelectModule } from "@ngx-formly/core/select";
import { SelectButtonModule } from "primeng-v17/selectbutton";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
import { SelectButtonReadonlyDirective } from "../../shared/primeng/select-button-readonly/select-button-readonly.directive";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "app-formly-selectbutton",
  templateUrl: "./formly-selectbutton.component.html",
  styleUrl: "./formly-selectbutton.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SelectButtonModule,
    SelectButtonReadonlyDirective,
    ReactiveFormsModule,
    FormElementMapModule,
    TestIdDirective,
    AsyncPipe,
    FormlyModule,
    FormlySelectModule,
  ],
})
export class FormlySelectbuttonComponent extends FieldType {}
